import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { SongCard } from "@/components/SongCard";

export default function SavedSongs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/me/saved-songs").then(({ data }) => setItems(data.items)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-head text-4xl font-black tracking-tighter mb-6">Saved Songs</h1>
      {items.length === 0 ? (
        <div className="card-surface rounded-2xl p-12 text-center text-muted-foreground">No saved songs yet. <Link to="/songs" className="text-neon-cyan">Browse the catalog →</Link></div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">{items.map((s, i) => <SongCard key={s.song_id} song={s} index={i} />)}</div>
      )}
    </div>
  );
}
